// Shared site chrome: logo, top navigation, footer.

export function Logo({ onClick }) {
  return (
    <div className="logo" onClick={onClick}>
      <img src="/battery-icon.svg" alt="Lithix-cell" style={{ width: 30, height: 30 }} />
      <span className="logo-name">Lithix-cell</span>
    </div>
  );
}

export function TopNav({ navigate, variant = 'marketing' }) {
  return (
    <header className="topnav">
      <Logo onClick={() => navigate('/')} />
      {variant === 'marketing' ? (
        <nav style={{ display: 'flex', gap: '0.6rem' }}>
          <button className="btn btn-ghost" onClick={() => navigate('/login')}>Sign in</button>
          <button className="btn btn-primary" onClick={() => navigate('/signup')}>Get started</button>
        </nav>
      ) : (
        <button className="btn btn-outline btn-sm" onClick={() => navigate('/')}>Back to home</button>
      )}
    </header>
  );
}

export function Footer({ navigate }) {
  return (
    <footer className="footer">
      <span>© 2026 Lithix-cell. All rights reserved.</span>
      <div className="links">
        <button onClick={() => navigate('/privacy')}>Privacy</button>
        <button onClick={() => navigate('/terms')}>Terms</button>
        <a href="mailto:info@lithix-cell.com">Contact</a>
      </div>
    </footer>
  );
}
